<template>
  <tabbed-terminal
    ref="terminal"
    :autoStart="autoStart"
    :username="username"
    :tabs="tabs"
    :startTab="startTab"
    :typeCharDelay="typeCharDelay"
  ></tabbed-terminal>
</template>
<script>
import TabbedTerminal from "@/components/terminal/TabbedTerminal";

const RESULT_TYPES = Object.freeze({
  LINK: Symbol(),
  CODE: Symbol(),
  LINK_LIST: Symbol()
});

const email = "steadmanben1@gmail.com";
const phone = "+447957261484";
const github = "https://github.com/SteadBytes";

const summaryCommandsData = [
  {
    command: "Ben.CV",
    result: {
      type: RESULT_TYPES.LINK,
      content: "Ben_Steadman_CV.pdf",
      href: "/Ben_Steadman_CV.pdf"
    }
  },
  {
    command: "Ben.current_location",
    result: { content: "Colchester, Essex, England" }
  },
  {
    command: "Ben.email",
    result: { type: RESULT_TYPES.LINK, content: email, href: `mailto:${email}` }
  },

  {
    command: "Ben.phone",
    result: { type: RESULT_TYPES.LINK, content: phone, href: `tel:${phone}` }
  },
  {
    command: "Ben.github",
    result: { type: RESULT_TYPES.LINK, content: github, href: github }
  },
  {
    command: "Ben.employment",
    result: {
      type: RESULT_TYPES.LINK,
      content: "Software Engineer at Jump Trading",
      href: "https://www.jumptrading.com"
    }
  },
  {
    command: "Ben.loves",
    result: {
      type: RESULT_TYPES.CODE,
      content: [
        "Reading (♥ Tolkien + Brandon Sanderson)",
        "Hiking/Outdoor Adventure",
        "Coffee",
        "Learning"
      ]
    }
  },
  {
    command: "Ben.always_learning",
    result: { type: RESULT_TYPES.CODE, content: true }
  }
];

const skillsCommandsData = [
  {
    command: "Ben.languages",
    result: {
      type: RESULT_TYPES.CODE,
      content: ["Python", "Go", "Rust", "Clojure", "Java"]
    }
  },
  {
    command: "Ben.systems_design",
    result: {
      type: RESULT_TYPES.CODE,
      content: ["Data Platform", "Stream Processing", "Event-based Communication", "Internal services & tooling", "ERP"]
    }
  },
  {
    command: "Ben.data_platform",
    result: { type: RESULT_TYPES.CODE, content: ["Apache Kafka", "KSQL", "Apache Spark"] }
  },
  {
    command: "Ben.web_backend",
    result: { type: RESULT_TYPES.CODE, content: ["Django", "Flask", "AWS Lambda", "Node.js"] }
  },
  {
    command: "Ben.devops",
    result: { type: RESULT_TYPES.CODE, content: ["Docker", "Linux", "Terraform", "AWS", "OpenStack"] }
  },
  {
    command: "Ben.machine_learning",
    result: { type: RESULT_TYPES.CODE, content: ["TensorFlow", "Keras", "OpenCV"] }
  },
  {
    command: "Ben.databases",
    result: { type: RESULT_TYPES.CODE, content: ["PostgreSQL", "SQlite", "MySQL", "Neo4J"] }
  },
  {
    command: "Ben.tools",
    result: { type: RESULT_TYPES.CODE, content: ["Git", "Bash", "General Linux CLI"] }
  }
];

const educationCommandsData = [
  {
    command: "Ben.udacity",
    result: {      type: RESULT_TYPES.LINK_LIST, content: [
        {
          href:
            "https://www.udacity.com/course/ai-artificial-intelligence-nanodegree--nd898",
          content: "Artificial Intelligence Nanodegree"
        },
        {
          href:
            "https://www.udacity.com/course/full-stack-web-developer-nanodegree--nd004",
          content: "Full Stack Web Developer Nanodegree"
        },
        {
          href: "https://www.udacity.com/course/intro-to-computer-science--cs101",
          content: "Intro to Computer Science CS101"
        }
      ]
    }
  },
  {
    command: "Ben.A_levels",
    result: { type: RESULT_TYPES.CODE, content: ["Computing", "Mathematics", "Physics", "Chemistry"] }
  }
];

function buildLinkResult(resultObj) {
  if (!resultObj.hasOwnProperty("href")) throw "Missing href";
  return buildLink(resultObj.content, resultObj.href);
}

function buildCodeResult(content) {
  return syntaxHighlight(JSON.stringify(content, null, 2));
}

function buildResultString(resultObj) {
  switch (resultObj.type) {
    case RESULT_TYPES.LINK:
      return buildLinkResult(resultObj);
    case RESULT_TYPES.CODE:
      return buildCodeResult(resultObj.content);
    case RESULT_TYPES.LINK_LIST:
      return resultObj.content.map(buildLinkResult);
    default:
      return resultObj.content;
  }
}

function syntaxHighlight(json) {
  json = json
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
  return json.replace(
    //eslint-disable-next-line
    /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
    function (match) {
      let cls = "number";
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = "key";
        } else {
          cls = "string";
        }
      } else if (/true|false/.test(match)) {
        cls = "boolean";
      } else if (/null/.test(match)) {
        cls = "null";
      }
      return `<span class="${cls}">${match}</span>`;
    }
  );
}

function buildLink(content, href) {
  return `<a href='${href}' target='_blank'>${content}</a>`;
}

function buildTerminalCommand(commandData) {
  return {
    command: commandData.command,
    result: buildResultString(commandData.result)
  };
}

const tabsData = {
  General: {
    commands: summaryCommandsData.map(buildTerminalCommand)
  },
  "Technical Skills": {
    commands: skillsCommandsData.map(buildTerminalCommand)
  },
  Education: {
    commands: educationCommandsData.map(buildTerminalCommand)
  }
};
export default {
  components: { TabbedTerminal },
  props: {
    username: String,
    typeCharDelay: { default: 50 }
  },
  data() {
    return {
      tabs: tabsData,
      startTab: "General",
      autoStart: false
    };
  },

  methods: {
    start() {
      this.$refs.terminal.startCurrent();
    }
  }
};
</script>
<style>
.terminal-username {
  color: #4cd964;
}
.terminal-prompt {
  color: #0095ff;
}

.string {
  color: #39a84c;
}
.number {
  color: #ffcc00;
}
.boolean {
  color: #ffcc00;
}
.null {
  color: #ffcc00;
}
.key {
  color: #ff3824;
}
</style>
